<div class="modal-shopping">

    <div class="modal-shopping__header">
        <button class="btn-close" type="button" (click)="closeModal()"><span class="btn-close__icon icon-close"></span></button>
        <picture class="base-card__image">
            <source media="(min-width: 600px)" srcset="{{image_url + itemDetail.image_url}}.png">
            <img class="img-responsive" src="{{image_url + itemDetail.image_url}}-mobile.png" alt="Product">
        </picture>
    </div>

    <div class="modal-shopping__body">

        <h2 class="text-complementary-two text-mid">{{itemDetail.name}}</h2>

        <div class="grid">
            <div class="intro grid-6">
                <h3 class="intro__price text-half text-secondary-base my-none d-flex ai-center">${{itemDetail.priceDiscount.toLocaleString()}}
                    <span *ngIf="itemDetail.discount > 0 " class="discount-rate bg-tertiary-base mx-xsmall text-grayscale-white text-xsmall">-{{itemDetail.discount}}%</span>
                </h3>
                <span *ngIf="itemDetail.discount > 0 && itemDetail.discount !== null" class="intro__discount text-small text-grayscale-gray-4">
                    ${{itemDetail.price.toLocaleString()}}
                </span>
                <p class="intro__info text-xsmall text-grayscale-gray-4">{{itemDetail.priceLabel}}</p>
            </div>
            <div class="validity grid-6" *ngIf="itemDetail.type === 'plan'">
                <h4 class="validity__month text-mid text-grayscale-gray-5 my-none">{{itemDetail.validity}} meses</h4>
                <p class="validity__info text-xsmall text-grayscale-gray-4">{{itemDetail.validityLabel}}</p>
            </div>
        </div>

        <div class="link">
            <a class="link__areas d-block text-center text-small text-primary-base my-mid" href="{{itemDetail.url}}">{{itemDetail.urlName}}</a>
        </div>

        <div class="select d-flex" *ngIf="itemDetail.type === 'plan'">
            <button type="submit" class="button secondary rounded d-flex text-small" (click)="onClickAddPlan(itemSelected)">
                <span class="icon material-icons pr-tiny text-grayscale-white text-small">shopping_cart</span>Agregar
            </button>
        </div>

        <div class="description">
            <p class="text-grayscale-gray-5 text-small my-half">{{itemDetail.topDescription}}</p>
        </div>

        <div class="properties">
            <ul class="list d-grid">
                <li class="list__item mb-thumb text-small text-grayscale-gray-6" *ngFor="let item of itemDetail.relevantCharacteristics; index as i">
                    <span class="icon icon-check_circle_outline pr-tiny text-thumb text-secondary-base"></span> {{itemDetail.relevantCharacteristics[i]}}
                </li>

            </ul>
            <p class="warning text-small text-grayscale-gray-4">{{itemDetail.terms}}</p>
        </div>

        <div class="d-flex jc-space-between my-half">
            <div class="state grid-6" *ngIf="itemDetail.unitTimeDuration !== ''">
                <h4 class="state__month text-mid text-grayscale-gray-5 my-none">{{itemDetail.duration}} {{itemDetail.unitTimeDuration}}</h4>
                <p class="state__info text-xsmall text-grayscale-gray-4">{{itemDetail.duratrionLabel}}</p>
            </div>
            <div class="state grid-6" *ngIf="itemDetail.type === 'product'">
                <h4 class="state__month text-mid text-grayscale-gray-5 my-none">{{itemDetail.validity}} meses</h4>
                <p class="state__info text-xsmall text-grayscale-gray-4">{{itemDetail.validityLabel}}</p>
            </div>
        </div>

        <div [innerHTML]="itemDetail.aditionalInfoHTML"></div>

        <div class="add-group d-flex jc-space-between p-xsmall my-half" *ngIf="itemDetail.type === 'product'">
            <div class="add-group__picker">
                <button type="button" class="btn-picker" (click)="remove()" ><span class="material-icons">remove</span></button>
                <span>{{count}}</span>
                <button type="button" class="btn-picker" (click)="add()" ><span class="material-icons">add</span></button>
            </div>
            <button class="button px-half rounded secondary text-xsmall" (click)="addToCar()" type="button">Agregar ${{total.toLocaleString()}}</button>
        </div>

    </div>

</div>